import * as StyleFunctions from '../utilities/StyleFunctions';
import IconFromStyle from '../StockItems/IconFromStyle';
import {useState, useEffect, useRef} from 'react';

function App(props) {

  var isError = props.isError;
  var doAScreenRef = props.doAScreenRef;
  var itemPath = props.itemPath;
  var allStyles = props.allStyles;
  var stylesToAdd = props.stylesToAdd;
  var addClasses = props.addClasses;
  var interactionFn = props.interactionFn;
  var clickFn = props.clickFn;
  var draggable = props.draggable;
  var onDragStart = props.onDragStart;
  var onDrag = props.onDrag;
  var onDragEnd = props.onDragEnd;
  var onMouseOver = props.onMouseOver;
  var onMouseOut = props.onMouseOut;

  const ref1 = useRef();


  useEffect(()=>{
    doAScreenRef(ref1, itemPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [isMouseOver, setMouseIsOver] = useState(false);

  function onMouseOverNett(e){
    setMouseIsOver(true);
    if (onMouseOver){
      onMouseOver(e);
    }
  }
  function onMouseOutNett(e){
    setMouseIsOver(false);
    if (onMouseOut){
      onMouseOut(e);
    }
  }

    if (isError){
      if (allStyles.buttonColor === 'danger'){
        allStyles.buttonColor = 'light';
      }else{
        allStyles.buttonColor = 'danger';
      }
    }
    var text1 = allStyles.text;
    if (text1 && text1.e){
      text1 = 'Error';
    }

    var addText = '';
    if (allStyles.buttonColor){
      var outline = allStyles.buttonOutline;
      if (outline){
        outline = 'outline-';
      }else{
        outline = '';
      }
      addText = ' btn-'+ outline + allStyles.buttonColor;
    }

    if (isMouseOver && allStyles.hoverColor){
      allStyles.backgroundColor = allStyles.hoverColor;
    }

    var iconBreak;
    var iconStyle = {icon:allStyles.icon, iconColor:allStyles.iconColor, iconHeight:allStyles.iconHeight, iconRotation:allStyles.iconRotation, hW:allStyles.hW, iconWidth:allStyles.iconWidth};
    var iconStuff = <IconFromStyle style={iconStyle}/>

    if (allStyles.icon && text1){
//      
      iconBreak = ' ';
    }
    StyleFunctions.expandBIU(allStyles);
    var disabled = false;
    if (interactionFn){
      disabled = allStyles.disabled;
    } 
    
    var className = StyleFunctions.iterateClassNames('btn' + addText + addClasses, ['buttonSize', 'tooltipShade'], allStyles);

    var dataToolTip = null;
    var toolTipLocation = false;

    if (allStyles.tooltipSet){
      dataToolTip = allStyles.toolText;
      toolTipLocation = allStyles.tooltipLocation;
    }

    return <div ref={ref1} className={className} onClick={clickFn} style={{...stylesToAdd, ...allStyles}} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} onMouseOver={onMouseOverNett} onMouseOut={onMouseOutNett} disabled={disabled} data-tooltip={dataToolTip} data-tooltip-location={toolTipLocation}>{iconStuff}{iconBreak}{text1}</div>

}
//




export default App;
